import PanelIndex from './panel/PanelIndex.vue';
import { frontendURL } from '../../../helper/URLHelper';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/arc'),
    name: 'arc_panel',
    roles: ['administrator', 'agent'],
    component: PanelIndex,
  },
];
